import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';

export const useAccountMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [copySuccess, setCopySuccess] = useState(false);

  const navigate = useNavigate();
  const { handleLogout, preferredUsername, userId } = useAuth();

  const handleAccountMenuOpen = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleAccountMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLogoutClick = useCallback(() => {
    handleAccountMenuClose();
    handleLogout();
  }, [handleAccountMenuClose, handleLogout]);

  const handleCopyId = useCallback(async (id: string) => {
    try {
      await navigator.clipboard.writeText(id);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch {
      setCopySuccess(false);
    }
  }, []);

  const handleMenuItemClick = useCallback(
    (to?: string) => {
      handleAccountMenuClose();
      if (to) {
        navigate(to);
      }
    },
    [handleAccountMenuClose, navigate]
  );

  const isMenuOpen = Boolean(anchorEl);

  return {
    anchorEl,
    copySuccess,
    isMenuOpen,
    preferredUsername,
    userId,
    handleAccountMenuOpen,
    handleAccountMenuClose,
    handleLogoutClick,
    handleCopyId,
    handleMenuItemClick,
  };
};
